import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../common/html/element'
import { selectCompanyInfo } from '../companyInfo/store/slice'
import classes from './index.module.scss'

export const FiscalYear = ({ otherFiscalYearEnd }) => {
  const companyInfo = useSelector(selectCompanyInfo)

  const fiscalYearEnd =
    otherFiscalYearEnd || new Date(companyInfo?.fiscalYearEnd).getFullYear()

  return (
    !!fiscalYearEnd && (
      <Element
        className={classes.fiscalYear}
        style={{ borderColor: '#9C9C9C' }}
      >
        <Translate
          value="companySummary.FISCAL_YEAR"
          style={{ fontWeight: 600, paddingRight: 0 }}
        />
        :&nbsp;{fiscalYearEnd}
      </Element>
    )
  )
}
